<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="title" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <div class="f-12 f-regular f-c-midgrey">
                        <p class="m-d-0">
                            Kode Akun: <span class="f-c-black f-14">{{ posted.idakun_keuangan }}</span>
                        </p>
                        <p class="m-d-0">Kode ini disediakan otomatis oleh sistem.</p>
                    </div>
                    <div class="form-field m-t-16">
                        <form class="akun-settlement">
                            <div class="form-group">
                                <SOInputRegular
                                    :title="'Nama rekening bank'"
                                    :placeholder="'Cth: Bank BNI'"
                                    :required="true"
                                    :disabled="isDisabled"
                                    v-model="posted.nama_rekening"
                                />
                                <ErrorMessage
                                    class="error"
                                    label="Nama rekening bank"
                                    :validation="$v.posted.nama_rekening"
                                />
                            </div>
                            <div class="form-group">
                                <SOInputNumeric
                                    :title="'Nomor Rekening'"
                                    :placeholder="'Nomor Rekening'"
                                    :required="true"
                                    :disabled="isDisabled"
                                    v-model="posted.nomor_rekening"
                                    ref="inptNomorRekening"
                                />
                                <ErrorMessage
                                    class="error"
                                    label="Nomor Rekening"
                                    :validation="$v.posted.nomor_rekening"
                                />
                            </div>
                            <div class="form-group">
                                <SOInputRegular
                                    :title="'Atas nama'"
                                    :placeholder="'Cth: Nella Kharisma'"
                                    :required="true"
                                    :disabled="isDisabled"
                                    v-model="posted.nama_pemilik"
                                />
                                <ErrorMessage class="error" label="Atas nama" :validation="$v.posted.nama_pemilik" />
                            </div>
                            <div class="form-group">
                                <SOInputRegular
                                    :title="'Keterangan (opsional)'"
                                    :placeholder="'keterangan...'"
                                    :disabled="isDisabled"
                                    v-model="posted.keterangan"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :primary="true"
                        :text="`Simpan`"
                        :full="true"
                        :id="`btn-add-akun-settlement`"
                        :disable="isDisabledSave"
                        :loading="isFetching"
                        @action="saveAkun"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputNumeric from "@/so-components/global/input/SOInputNumeric";
import ErrorMessage from "@/component-items/ErrorMessage";

import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "ModalAddAkun",
    components: {
        SOSlotModal,
        SOButton,
        SOInputRegular,
        SOInputNumeric,
        ErrorMessage,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setBackLink(from.name);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            backLink: "mesin.edc.add",
            modalId: "modal-add-akun",
            title: "Buat Akun Settlement",
            isDisabled: true,
            posted: {
                idakun_keuangan: "",
                nama_rekening: "",
                nama_pemilik: "",
                nomor_rekening: "",
                keterangan: "",
            },
        };
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    validations: {
        posted: {
            nama_rekening: {
                required,
                minLength: minLength(3),
            },
            nama_pemilik: {
                required,
                minLength: minLength(3),
            },
            nomor_rekening: {
                required,
                minLength: minLength(8),
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
        }),
        isDisabledSave() {
            let { idakun_keuangan, nama_rekening, nama_pemilik, nomor_rekening } = this.posted;
            let isDisabled = idakun_keuangan ? false : true;
            isDisabled = !isDisabled && nama_rekening ? false : true;
            isDisabled = !isDisabled && nama_pemilik ? false : true;
            isDisabled = !isDisabled && nomor_rekening ? false : true;
            return isDisabled;
        },
    },
    methods: {
        ...mapActions({
            getKodeAkunSettlement: `${moduleName}/getKodeAkunSettlement`,
            createKodeAkun: `${moduleName}/createKodeAkun`,
            getListSettlement: `${moduleName}/getListSettlement`,
            setSelectedPosted: `${moduleName}/setSelectedPosted`,
            setFetching: `${moduleName}/setFetching`,
        }),
        async init() {
            await this.resetState();
            await this.loadKodeAkun();
        },
        resetState() {
            this.posted.nama_rekening = "";
            this.posted.nama_pemilik = "";
            this.posted.nomor_rekening = "";
            this.posted.keterangan = "";
        },
        loadKodeAkun() {
            this.setFetching(true);
            let akun = this.getKodeAkunSettlement();
            akun.then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        this.posted.idakun_keuangan = data.idakun_keuangan_rekening;
                        this.setDisabledInput(false);
                    } else {
                        this.$toast.error(msg);
                    }
                }
                this.setFetching(false);
            }).catch((e) => {
                this.setFetching(false);
                this.$toast.error(e);
            });
        },
        async back(optionAkun = "show") {
            await this.$router.push({ name: this.backLink, query: { optionAkun } });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setBackLink(linkName) {
            this.backLink = linkName;
        },
        setDisabledInput(val) {
            this.isDisabled = val;
        },
        errorValidation() {
            let { nama_rekening, nama_pemilik, nomor_rekening } = this.$v.posted;
            nama_rekening.$touch();
            nama_pemilik.$touch();
            nomor_rekening.$touch();

            return nama_rekening.$invalid || nama_pemilik.$invalid || nomor_rekening.$invalid;
        },
        saveAkun() {
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            this.setFetching(true);

            let createAkun = this.createKodeAkun(this.posted);
            createAkun
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            this.getListSettlement();
                            this.setSelectedPosted({ target: "idakun_keuangan_settlement", val: data.id });
                            this.back("hide");
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
